import axios, { AxiosInstance, CancelToken } from 'axios';
import get from 'lodash/get';
import config from 'config/Config';
import { initAxios } from 'utils/axios';
import { DailyCapacityPerWeek } from 'utils/types/dailyTeamsCapacity';

export interface FetchDailyTeamMembersCapacityApiResponse {
  id: string;
  dailyCapacities: {
    weeks: DailyCapacityPerWeek;
  };
}

class TeamMemberProjectsCapacityAPI {
  instance: AxiosInstance;

  constructor() {
    this.instance = initAxios(config.get('backendURL'), 'resourcing');
  }

  fetchDailyTeamMemberProjectCapacity: (
    url: string,
    cancelToken?: CancelToken
  ) => Promise<FetchDailyTeamMembersCapacityApiResponse> = async (
    url,
    cancelToken
  ) => {
    const response =
      await this.instance.get<FetchDailyTeamMembersCapacityApiResponse>(url, {
        cancelToken,
      });
    if (axios.isAxiosError(response)) {
      const errorMessage = get(response, 'response.data.message', '');
      throw errorMessage;
    }
    return response.data;
  };
}

const teamMemberProjectsCapacityAPI = new TeamMemberProjectsCapacityAPI();
export default teamMemberProjectsCapacityAPI;
